<template>
    <div>
        <el-collapse v-model="activeNames" @change="handleChange">
            <el-collapse-item :name="requireGoodsItemDto.ukKey" v-for="(requireGoodsItemDto, index) in requireGoodsItemDtoList">
                <template slot="title">
                    <div class="inline-block ml5">
                        <span class="mr5">请购机构：</span>
                        <span>{{requireGoodsItemDto.requireComName || "无"}}</span>
                    </div>
                    <div class="inline-block ml30">
                        <span class="mr5">供应商：</span>
                        <span>{{requireGoodsItemDto.vendorName || "无"}}</span>
                    </div>
                    <div class="inline-block ml30">
                        <span class="mr5">合同名称：</span>
                        <span>{{requireGoodsItemDto.contractTitle || "无"}}</span>
                    </div>
                </template>
                <div class="sub-table-layout mt10">
                    <template v-if="requireGoodsItemDto.itemList != null && requireGoodsItemDto.itemList.length > 0">
                        <el-table :data="requireGoodsItemDto.itemList" style="width: 100%" border>
                            <el-table-column prop="name" label="名称" width="150"></el-table-column>
                            <el-table-column prop="goodsCatName" label="分类名称" width="150"></el-table-column>
                            <el-table-column prop="goodsBrandName" label="品牌名称" width="100"></el-table-column>
                            <el-table-column prop="model" label="型号" width="100"></el-table-column>
                            <el-table-column prop="fixedSpec" label="规格" width="100"></el-table-column>
                            <el-table-column prop="unit" label="单位" width="80"></el-table-column>
                            <el-table-column prop="vendorName" label="供应商" width="150"></el-table-column>
                            <el-table-column label="组装件" v-if="!lowCostFlag" width="100">
                                <template slot-scope="scope">
                                    <span v-if="scope.row.asmblAccFlag">是</span>
                                </template>
                            </el-table-column>
                            <el-table-column label="含税价(元)" prop="price">
                                <template slot-scope="scope">
                                    <span v-if="scope.row.price != null">{{scope.row.price.toFixed(2)}}</span>
                                    <span v-else>0.00</span>
                                </template>
                            </el-table-column>
                            <el-table-column label="税率(%)" prop="taxRate">
                                <template slot-scope="scope">
                                    <span v-if="scope.row.taxRate != null">{{scope.row.taxRate.toFixed(2)}}</span>
                                    <span v-else>0.00</span>
                                </template>
                            </el-table-column>
                            <el-table-column label="未税价(元)" prop="ntxPrice">
                                <template slot-scope="scope">
                                    <span v-if="scope.row.ntxPrice != null">{{scope.row.ntxPrice.toFixed(2)}}</span>
                                    <span v-else>0.00</span>
                                </template>
                            </el-table-column>
                            <el-table-column label="请求数量" align="right" width="80">
                                <template slot-scope="scope">
                                    <el-input type="text" v-model.number="scope.row.quantity" min="0" @change="setQuantity(scope.$index, index)"></el-input>
                                </template>
                            </el-table-column>
                            <el-table-column prop="desc" label="描述"></el-table-column>
                            <el-table-column align="left" label="操作" width="200">
                                <template slot-scope="scope">
                                    <a class="swb-btn-link" v-if="scope.row.asmblAccFlag" @click="addAccVoucher(scope.$index, index)">新增供应商</a>
                                    <a class="swb-btn-link" v-if="!scope.row.asmblAccFlag" @click="addAssetVoucher(scope.$index,index)">新增供应商</a>
                                </template>
                            </el-table-column>
                        </el-table>
                    </template>
                </div>
            </el-collapse-item>
        </el-collapse>
    </div>
</template>
<script>
    import { Utils, $ } from '../../app.base'
    import { Vue, MsgBox, DomSizeWatcher, Routes } from '../../app.vues'
    import devcReqrApi from '../../api/devcReqr'
    import retailerApi from '../../api/retailer'
    import { goodsInSelectDlg } from './dialog'
    //
    export default {
        name: 'swb-device-require-voucher-split-order',
        desc: '配货单新增',
        props: {
            voucherIds: {
                type: Array,
                default: null
            },
            itemFilter: {
                type: Object,
                default: null
            },
            lowCostFlag: { // 选择耗材信息
                type: Boolean,
                default: false
            }
        },
        watch: {
            itemFilter: function (newValue, oldVal) {
                this.asmblItemList = Utils.merge([], newValue.asmblItemList) || [];
                this.goodsItemList = Utils.merge([], newValue.goodsItemList) || [];
            }
        },
        data: function () {
            return {
                activeNames: [],
                requireGoodsItemDtoList: [],
                goodsItemList: [],
                asmblItemList: [],
                requireGoodsAsmblItemList: [],
                requireGoodsItemList: [],
            }
        },
        created: function () {
            this.getRequireGoodsItemDtoList();
        },
        methods: {
            handleChange(val) {
            },
            validateQuantity: function (rule, value, callback) {
                if(Utils.isNoB(value)) {
                    callback(new Error('请输入申请数量'));
                } else {
                    if(!Utils.isNumber(value) || value <= 0) {
                        callback(new Error('请输入大于0的数字'));
                    } else {
                        callback();
                    }
                }
            },
            getRequireGoodsItemDtoList: function () {
                let self = this;
                let voucherIds = self.voucherIds;
                let postData = {
                    voucherIds: voucherIds
                };
                devcReqrApi.getRequireGoodsItemDtoByVoucherIds(postData, function (result) {
                    if(result.type == "info") {
                        let requireGoodsItemDtoList = result.data;
                        let goodsItems = [];
                        let asmblItemList = [];
                        for(let i = 0; i < requireGoodsItemDtoList.length; i++) {
                            let goodsItemList = [];
                            let requireGoodsItemDto = requireGoodsItemDtoList[i];
                            let requireGoodsItemList = requireGoodsItemDto.requireGoodsItemList || [];
                            let requireGoodsAsmblItemList = requireGoodsItemDto.requireGoodsAsmblItemList || [];
                            requireGoodsAsmblItemList.forEach(function (item) {
                                item.asmblAccFlag = true;
                            })
                            requireGoodsAsmblItemList = Utils.merge([], requireGoodsAsmblItemList);
                            let itemList = requireGoodsItemList.concat(requireGoodsAsmblItemList);
                            requireGoodsItemDto.itemList = itemList;
                            requireGoodsItemDto.ukKey = requireGoodsItemDto.contractId + '' + requireGoodsItemDto.requireComId + '' + requireGoodsItemDto.vendorId;
                            goodsItems = goodsItems.concat(requireGoodsItemList);
                            asmblItemList = asmblItemList.concat(requireGoodsAsmblItemList);
                        }
                        self.activeNames = requireGoodsItemDtoList.pluck('ukKey');
                        self.requireGoodsItemList = goodsItems;
                        self.requireGoodsAsmblItemList = asmblItemList;
                        self.requireGoodsItemDtoList = Utils.merge([], requireGoodsItemDtoList);
                    } else {
                        MsgBox.warning(result.message);
                    }
                })
            },
            setQuantity: function (index, dtoIndex) {
                let self = this;
                let requireGoodsItemDtoList = self.requireGoodsItemDtoList;
                let requireGoodsItemDto = requireGoodsItemDtoList[dtoIndex];
                let itemList = requireGoodsItemDto.itemList || [];
                let dbItem = itemList[index];
                if(Utils.isNoB(dbItem.quantity)) {
                    dbItem.quantity = 0;
                }
                let goodsItemId = dbItem.goodsItemId;
                let voucherId = dbItem.voucherId;
                if(dbItem.asmblAccFlag) {
                    requireGoodsItemDtoList.forEach(function (dtoItem) {
                        let itemList = dtoItem.requireGoodsAsmblItemList || [];
                        itemList.forEach(function (item) {
                            if(item.goodsItemId == goodsItemId && item.deviceId == dbItem.deviceId) {
                                item.quantity = dbItem.quantity;
                            }
                        })
                    });
                } else {
                    requireGoodsItemDtoList.forEach(function (dtoItem) {
                        let itemList = dtoItem.requireGoodsItemList || [];
                        itemList.forEach(function (item) {
                            if(item.voucherId == voucherId && item.deviceId == dbItem.deviceId) {
                                let onlyForAsmblAcc = item.onlyForAsmblAcc;
                                item.quantity = dbItem.quantity;
                                if((dbItem.quantity <= 0 && !onlyForAsmblAcc)) {
                                    item.onlyForAsmblAcc = true;
                                } else if(dbItem.quantity > 0 && onlyForAsmblAcc) {
                                    item.onlyForAsmblAcc = false;
                                }
                            }
                        })
                    });
                }
                self.requireGoodsItemDtoList = Utils.merge([], requireGoodsItemDtoList);
            },
            addAccVoucher: function (index, dtoIndex) {
                let self = this;
                let requireGoodsItemDtoList = self.requireGoodsItemDtoList;
                let requireGoodsItemDto = requireGoodsItemDtoList[dtoIndex];
                let itemList = requireGoodsItemDto.itemList || [];
                let dbItem = itemList[index];
                let goodsItemId = dbItem.goodsItemId;
                let voucherId = dbItem.voucherId;
                let deviceIds = [];
                //
                let requireGoodsAsmblItemList = [];
                requireGoodsItemDtoList.forEach(function (dtoItem) {
                    let itemList = dtoItem.requireGoodsAsmblItemList || [];
                    itemList.forEach(function (item) {
                        if(item.goodsItemId == goodsItemId) {
                            requireGoodsAsmblItemList.push(item);
                        }
                    })
                });
                requireGoodsAsmblItemList.forEach(function (item) {
                    if(item.goodsItemId == goodsItemId) {
                        deviceIds.push(item.deviceId);
                    }
                });
                //
                let asmblItemList = self.asmblItemList || [];
                asmblItemList.forEach(function (item) {
                    if(item.goodsItemId == goodsItemId) {
                        deviceIds.push(item.deviceId);
                    }
                });
                //
                self.getRetailerComId(requireGoodsItemDto.requireComId, function (result) {

                    let bizAreaId = result.bizAreaId != null ? result.bizAreaId : -1;
                    let bizFormId = result.bizFormId != null ? result.bizFormId : -1;
                    let filter = {
                        assetAccFlag: true,
                        catId: dbItem.goodsCatId,
                        brandId: dbItem.goodsBrandId,
                        bizAreaId: bizAreaId,
                        bizAreaFlag: true,
                        bizFormFlag: true,
                        skuFlag: true,
                        bizFormId: bizFormId,
                        goodsModel: dbItem.model,
                        vendorId: requireGoodsItemDto.vendorId,
                        voucherFlag: true,
                        disabled: false,
                    };
                    let params = {};
                    params.filter = filter;
                    params.checkIds = deviceIds;
                    params.showTable = true;
                    params.showCatBrandTable = true;
                    params.showCatBrandModelTable = true;
                    params.showCatTable = true;
                    goodsInSelectDlg(params, function (result) {
                        let resultItemList = result || [];
                        resultItemList.forEach(function (deviceRequirer) {
                            index = index + 1;
                            let item = {};
                            item.deviceId = deviceRequirer.id;
                            item.name = deviceRequirer.name;
                            item.asmblAccFlag = deviceRequirer.asmblAccFlag;
                            item.vendorId = deviceRequirer.vendorId;
                            item.vendorName = deviceRequirer.vendorName;
                            item.centBuyMode = dbItem.centBuyMode;
                            item.requireComId = requireGoodsItemDto.requireComId;
                            item.requireComId = requireGoodsItemDto.requireComId;
                            item.requireComName = requireGoodsItemDto.requireComName;
                            if(Utils.isTrue(deviceRequirer.contractEnded)) {
                                item.contractId = -1;
                            } else {
                                item.contractTitle = deviceRequirer.contractTitle;
                                item.contractId = deviceRequirer.contractId;
                                item.contractDateStart = deviceRequirer.contractDateStart;
                                item.contractDateEnd = deviceRequirer.contractDateEnd;
                            }

                            item.centBuyMode = dbItem.centBuyMode;
                            item.skuId = deviceRequirer.skuId;
                            item.accDefId = deviceRequirer.assetDefId;
                            item.model = deviceRequirer.model;
                            item.fixedSpec = deviceRequirer.fixedSpec;
                            item.voucherId = voucherId;
                            item.goodsItemId = goodsItemId;
                            item.modelSpec = deviceRequirer.modelSpec;
                            item.goodsCatId = deviceRequirer.goodsCatId;
                            item.goodsBrandId = deviceRequirer.goodsBrandId;
                            item.goodsCatName = deviceRequirer.goodsCatName;
                            item.goodsBrandName = deviceRequirer.goodsBrandName;
                            item.unit = deviceRequirer.unit;
                            item.price = deviceRequirer.price;
                            item.ntxPrice = deviceRequirer.ntxPrice;
                            item.taxRate = deviceRequirer.taxRate;
                            item.quantity = 1;
                            item.created = true;
                            item.setQuantity = 1;
                            if(deviceIds.indexOf(item.deviceId) > -1) {
                                MsgBox.warning(item.name + "已经包含，不可再次添加");
                                return;
                            }
                            asmblItemList.push(item);
                            //
                            self.asmblItemList = Utils.merge([], asmblItemList);
                        });
                    })
                })
            },

            addAssetVoucher: function (index, dtoIndex) {
                let self = this;
                let requireGoodsItemDtoList = self.requireGoodsItemDtoList;
                let requireGoodsItemDto = requireGoodsItemDtoList[dtoIndex];
                let itemList = requireGoodsItemDto.itemList || [];
                let goodsItem = itemList[index];
                let voucherId = goodsItem.voucherId;
                let deviceIds = [];
                let requireGoodsItems = [];
                requireGoodsItemDtoList.forEach(function (dtoItem) {
                    let itemList = dtoItem.requireGoodsItemList || [];
                    itemList.forEach(function (item) {
                        if(item.voucherId == voucherId) {
                            requireGoodsItems.push(item);
                        }
                    })
                });
                requireGoodsItems.forEach(function (item) {
                    if(item.voucherId == voucherId) {
                        deviceIds.push(item.deviceId);
                    }
                });
                let goodsItemList = self.goodsItemList || [];
                goodsItemList.forEach(function (item) {
                    if(item.voucherId == voucherId) {
                        deviceIds.push(item.deviceId);
                    }
                });
                //
                self.getRetailerComId(requireGoodsItemDto.requireComId, function (result) {
                    let bizAreaId = result.bizAreaId != null ? result.bizAreaId : -1;
                    let bizFormId = result.bizFormId != null ? result.bizFormId : -1;
                    let filter = {
                        assetDefFlag: true,
                        catId: goodsItem.goodsCatId,
                        brandId: goodsItem.goodsBrandId,
                        goodsModel: goodsItem.model,
                        bizAreaId: bizAreaId,
                        bizAreaFlag: true,
                        bizFormFlag: true,
                        bizFormId: bizFormId,
                        vendorId: goodsItem.vendorId,
                        voucherFlag: true,
                        disabled:false,
                    };
                    let params = {};
                    params.filter = filter;
                    params.checkIds = deviceIds;
                    params.centBuyMode = true;
                    params.showTable = true;
                    params.showCatBrandTable = true;
                    params.showCatBrandModelTable = true;
                    params.showCatTable = true;
                    params.lowCostFlag = self.lowCostFlag;
                    goodsInSelectDlg(params, function (result) {
                        let itemList = result || [];
                        let selectDeviceIds = [];
                        for(let i = 0; i < itemList.length; i++) {
                            let deviceRequirer = itemList[i];
                            index = index + 1;
                            let item = {};
                            item.deviceId = deviceRequirer.id;
                            item.name = deviceRequirer.name;
                            item.asmblAccFlag = deviceRequirer.asmblAccFlag;
                            item.vendorId = deviceRequirer.vendorId;
                            item.vendorName = deviceRequirer.vendorName;
                            if(Utils.isTrue(deviceRequirer.contractEnded)) {
                                item.contractId = -1;
                            } else {
                                item.contractTitle = deviceRequirer.contractTitle;
                                item.contractId = deviceRequirer.contractId;
                                item.contractDateStart = deviceRequirer.contractDateStart;
                                item.contractDateEnd = deviceRequirer.contractDateEnd;
                            }
                            item.centBuyMode = deviceRequirer.centBuyMode;
                            item.reqCentBuyMode = deviceRequirer.centBuyMode;
                            item.skuId = deviceRequirer.skuId;
                            item.assetDefId = deviceRequirer.assetDefId;
                            item.model = deviceRequirer.model;
                            item.fixedSpec = deviceRequirer.fixedSpec;
                            item.modelSpec = deviceRequirer.modelSpec;
                            item.goodsCatId = deviceRequirer.goodsCatId;
                            item.goodsBrandId = deviceRequirer.goodsBrandId;
                            item.goodsCatName = deviceRequirer.goodsCatName;
                            item.goodsBrandName = deviceRequirer.goodsBrandName;
                            item.unit = deviceRequirer.unit;
                            item.quantity = 1;
                            item.price = deviceRequirer.price;
                            item.ntxPrice = deviceRequirer.ntxPrice;
                            item.taxRate = deviceRequirer.taxRate;
                            item.voucherId = voucherId;
                            item.requireComId = requireGoodsItemDto.requireComId;
                            item.requireComName = requireGoodsItemDto.requireComName;
                            if(deviceIds.indexOf(item.deviceId) > -1) {
                                MsgBox.warning(item.name + "已经包含，不可再次添加");
                                return;
                            }
                            item.created = true;
                            item.itemList = [];
                            goodsItemList.push(item);
                            //
                            selectDeviceIds.push(deviceRequirer.id);
                        }
                        self.goodsItemList = Utils.merge([], goodsItemList);
                        self.getAccDefList(selectDeviceIds, bizAreaId, bizFormId, voucherId);
                    });
                })
            },
            // 根据入选商品查询对应的组装件信息
            getAccDefList: function (deviceIds, bizAreaId, bizFormId, voucherId) {
                let self = this;
                let goodsItemList = self.goodsItemList;
                let postData = {
                    deviceIds: deviceIds,
                    bizAreaId: bizAreaId,
                    bizFormId: bizFormId
                };
                devcReqrApi.getAdoptedDeviceAsmblAccList(postData, function (result) {
                    if(result.type == "info") {
                        let itemMap = result.data || [];
                        for(let i = 0; i < goodsItemList.length; i++) {
                            let goodsItem = goodsItemList[i];
                            if(deviceIds.indexOf(goodsItem.deviceId) > -1 && voucherId == goodsItem.voucherId) {
                                let itemList = itemMap[goodsItem.deviceId] || [];
                                let quantity = 0;
                                itemList.forEach(function (item) {
                                    quantity = quantity + item.quantity;
                                    item.setQuantity = item.quantity;
                                });
                                goodsItem.asmblAccReqCount = quantity;
                                goodsItem.asmblAccSetCount = quantity;
                                goodsItem.itemList = Utils.merge([], itemList);
                            }
                        }
                        self.goodsItemList = Utils.merge([], goodsItemList);
                    } else {
                        MsgBox.warning(result.message);
                    }
                });
            },
            getRetailerComId: function (comId, callBack) {
                let self = this;
                let postData = {
                    comId: comId
                };
                retailerApi.getRetailerCom(postData, function (result) {
                    if(result.type == "info") {
                        let retailerCom = result.data;
                        callBack(retailerCom)

                    }
                })
            },
            getDlgResult: function () {
                let self = this;
                let asmblItemList = self.asmblItemList || [];
                let goodsItemList = self.goodsItemList || [];
                let result = {};
                let requireGoodsAsmblItemList = [];
                let requireGoodsItemList = [];
                let requireGoodsItemDtoList = self.requireGoodsItemDtoList;
                for(let i = 0; i < requireGoodsItemDtoList.length; i++) {
                    let requireGoodsItemDto = requireGoodsItemDtoList[i];
                    let itemList = requireGoodsItemDto.itemList;
                    for(let j = 0; j < itemList.length; j++) {
                        let item = itemList[j];
                        if(item.asmblAccFlag) {
                            requireGoodsAsmblItemList.push(item);
                        } else {
                            requireGoodsItemList.push(item);
                        }
                    }
                }
                result.data = {
                    asmblItemList: asmblItemList,
                    goodsItemList: goodsItemList,
                    requireGoodsAsmblItemList: requireGoodsAsmblItemList,
                    requireGoodsItemList: requireGoodsItemList
                }
                return result;
            },
        }
    }
</script>

<style>
    .el-collapse-item .el-collapse-item__header {
        background: aliceblue;
    }

</style>



// WEBPACK FOOTER //
// src/compo/retailer/DeviceRequireVoucherSplitOrder.vue